import QaiChallengeFilterViewModel from "../QaiScorecardChallenge/Shared/ViewModels/QaiChallengeFilterViewModel";

export default function getActiveFilterDateRangeFlag(filters: QaiChallengeFilterViewModel) {
    var activeDateRangeFlag = '';
    if (filters.flagThisWeek) activeDateRangeFlag = 'This Week'
    if (filters.flagLastWeek) activeDateRangeFlag = 'Last Week'
    if (filters.flagThisMonth) activeDateRangeFlag = 'This Month'
    if (filters.flagLastMonth) activeDateRangeFlag = 'Last Month'
    return activeDateRangeFlag;
}